// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2xZ6a","boxTitle":"Qualiphy_boxTitle__2rDBi","box":"Qualiphy_box__2aq5L","toggleWrap":"Qualiphy_toggleWrap__cEBsB"};